module.exports = __webpack_public_path__ + "theStyleRoomBlack.33177120e89be84cde8b4c56602bf5f2.svg";